/**
 * Created by ivo on 03.02.17.
 */
import "./Notify.css";
import React from 'react';
import PropTypes from 'prop-types';
import NotifyItem from './NotifyItem';


const propTypes = {
    items: PropTypes.array.isRequired,
    onHide: PropTypes.func
};

const defaultProps = {};

class Notify extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div className="notify-container">
                {this.props.items.map(
                    (item) =>
                        <NotifyItem
                            id={item.id}
                            key={item.id}
                            onHide={this.props.onHide}
                            level={item.level}
                            title={item.title}
                            message={item.message}/>
                )}
            </div>
        );
    }
}

Notify.propTypes = propTypes;
Notify.defaultProps = defaultProps;

export default Notify;
